import { useWidgetTitleHeight } from "./AHWidgetTitle";
import { Box } from "../AHTheme/Box";
import { ImageProps, Image } from "expo-image";
import { AHText, AHTextFonts } from "../Text/AHText";

export const AHWidgetTitleLogo = (
  props: ImageProps & { subtitle?: React.ReactNode }
) => {
  const height = useWidgetTitleHeight();
  return (
    <Box
      spaceHorizontal="small"
      spaceTop="small"
      spaceBottom="xxsmall"
      style={[
        {
          flexDirection: "row",
          height,
          justifyContent: "space-between",
          alignItems: "center",
        },
      ]}
    >
      <Image
        style={{ flex: 1, height: "100%" }}
        contentFit="contain"
        contentPosition="left center"
        {...props}
      />
      {props.subtitle ? (
        <AHText
          type="subtitle"
          allowFontScaling={false}
          color={"darkerText"}
          font={AHTextFonts.BOLDER}
          numberOfLines={1}
        >
          {props.subtitle}
        </AHText>
      ) : null}
    </Box>
  );
};
